import React from 'react';
import classNames from 'classnames';
import stringUtils from '../../utils/string';
import classes from './styles/index.module.scss';
import { CheckboxProps } from './types';
import { CheckMark } from '../Icons/CheckMark';

export const HELLOFLEX_CHECKBOX_CLASS = 'helloflex-checkbox';

export const Checkbox: React.FC<React.PropsWithChildren<CheckboxProps>> = ({
	labelLight,
	labelWhite,
	labelCentered,
	checked,
	isRequired,
	partial,
	disabled,
	previewMode,
	hasPreviewBorderBottom,
	name,
	labelClassName,
	className,
	trackClassName,
	trackSectionClassName,
	label,
	children,
	onChange,
	tabIndex = 0,
	size = 'default',
	// @ts-ignore
	labelTag = 'label',
}) => {
	const handleChange = () => {
		if (disabled || previewMode) {
			return;
		}

		onChange && onChange(!checked);
	};

	const checkboxClasses = classNames(
		HELLOFLEX_CHECKBOX_CLASS,
		classes.checkbox,
		{
			[classes.checkbox_checked]: checked,
			[classes.checkbox_disabled]: disabled || previewMode,
			[classes.checkbox_preview]: previewMode,
			[classes.checkbox_partial]: partial,
			[classes.checkbox_previewBorder]: hasPreviewBorderBottom && previewMode,
			[classes.checkbox_small]: size === 'small',
		},
		className,
	);

	const componentLabelClassName = classNames(
		classes.label,
		{
			[classes.label_light]: labelLight && !previewMode,
			[classes.label_white]: labelWhite,
			[classes.label_centered]: labelCentered,
			[classes.label_required]: isRequired,
		},
		labelClassName,
		className,
	);

	const trackClasses = classNames(classes.track, trackClassName);

	const trackSectionClasses = classNames(classes.trackSection, trackSectionClassName);
	const hasLabel = !stringUtils.isNullOrEmpty(label);
	const ariaLabel = name || 'checkbox';
	const currentTabIndex = previewMode || disabled ? -1 : tabIndex;

	const LabelTag = labelTag ? labelTag : 'div';

	const checkMarkSize = size === 'default' ? '16px' : '12px';

	return (
		<LabelTag
			className={checkboxClasses}
			role='checkbox'
			aria-checked={checked}
		>
			<div className={trackSectionClasses}>
				<div className={trackClasses} />
				<CheckMark
					className={classes.thumb}
					height={checkMarkSize}
					width={checkMarkSize}
					data-checkbox-thumb-checked={checked}
				/>
			</div>

			<input
				type='checkbox'
				aria-label={ariaLabel}
				name={name}
				onChange={handleChange}
				checked={checked}
				tabIndex={currentTabIndex}
				disabled={disabled}
			/>
			{hasLabel && <div className={componentLabelClassName}>{label}</div>}
			{children && <div className={componentLabelClassName}>{children}</div>}
		</LabelTag>
	);
};
